import { SVGProps } from 'react';

const ZepterNeutral = ({ props, size = 64 }: { props?: SVGProps<SVGSVGElement>; size?: string | number }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 64 64" fill="none" {...props}>
    <rect width="64" height="64" fill="#161616" rx="32" />
    <path
      fill="#888"
      d="M41.087 48H23l1.438-4.04h16.649V48Zm-.004-6.102h-14.88l1.272-3.612h13.608v3.612Zm0-5.681H29.415l1.115-3.178h10.553v3.178Zm-7.53-5.248H23v-3.186h11.676l-1.123 3.186Zm4.329-8.86-1.266 3.605H23V22.11h14.882Zm1.767-2.069H23V16h18.087l-1.438 4.04Z"
    />
  </svg>
);

export default ZepterNeutral;
